import { Injectable, EventEmitter } from '@angular/core';
import { from, Subscription, Observable } from 'rxjs';
import { AB_REFRESH_SESSION_TIME } from '../../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class IdleService {
  private isRunningValue = false;
  private userEvents: Observable<Event>;
  private idleSubsctiption: Subscription;
  private timeout;

  private _timeUp = false;
  private _activity = false;

  constructor() {
  }

  private set timeUp(value) {
    this._timeUp = value;

    if (value) {
      clearTimeout(this.timeout);
    } else {
      this.timeout = setTimeout(() => {
        this.timeUp = true;
      }, AB_REFRESH_SESSION_TIME * 60000);
    }

    if (value && this._activity) {
      this.onActivity.emit(event);
      this.activity = false;
      this.timeUp = false;
    }
  }

  private set activity(value) {
    this._activity = value;

    if (value) {
      this.stopCheckUserActivity();
    } else {
      this.startCheckUserActivity();
    }

    if (value && this._timeUp) {
      this.onActivity.emit(event);
      this.timeUp = false;
      this.activity = false;
    }
  }

  public onActivity = new EventEmitter();

  get isRunning() {
    return this.isRunningValue;
  }

  configIdle(events: Observable<Event>) {
    this.userEvents = events;
    this.doRefreshToken();
  }

  doRefreshToken() {
    this.activity = false;
    this.timeUp = false;
  }

  stopRefreshToken() {
    this.stopCheckUserActivity();
    clearTimeout(this.timeout);
  }

  startCheckUserActivity() {
    if (this.userEvents) {
      this.isRunningValue = true;
      this.idleSubsctiption = from(this.userEvents).subscribe(event => {
        if (event instanceof MessageEvent) {
          let data;
          try {
            data = event.data ? JSON.parse(event.data) : {};
          } catch {
            data = { channelName: undefined };
          }

          if (data.channelName) {
            this.onActivity.emit(event);
          }
        } else {
          this.activity = true;
        }
      });
    }
  }

  stopCheckUserActivity() {
    this.isRunningValue = false;
    if (this.idleSubsctiption) {
      this.idleSubsctiption.unsubscribe();
    }
   }
}
